import { api } from 'api'
import { StatusForCompanyEnum } from 'api/enums'
import { WorkStatusEnum } from './shiftTimeline'

type GetShiftWorkRequest = {
  companyId: number
  shiftId: number
}

type GetShiftWorkResponseWork = {
  id: number
  status: WorkStatusEnum
  isNoShow: boolean
  worker: {
    id: number
    name: string
    profilePicUrl: string | null
    statusForCompany: StatusForCompanyEnum | null
  }
  callouts: { status: 'requested' | 'approved' | 'rejected' }[]
  trips: {
    status: string | null
    shareUrl: string | null
    eta: string | null
    etaSeconds: number | null
    locationStatus: string | null
    serviceDeviceId: string | null
  }[]
  employerApprovedBy: { id: number; name: string } | null
  createdAt: string
  confirmedAt: string | null
  startedAt: string | null
  completedAt: string | null
  employerApprovedAt: string | null
  reservationExpiresAt: string | null
  reservationNotifiedAt: string | null
  leftEarly: boolean
  finishedEarlyCategory: string | null
  lunchLengthOverrideInMinutes: number | null
  supervisorReasonEarlyClockOut: string | null
  supervisorMarkedNoShow: boolean
  pendingAdminReview: boolean
  earnings: string
  timeWorkedSeconds: number | null
  isPositionLocationDebut: boolean
}

type GetShiftWorkResponseUnableToAttendWork = {
  id: number
  status: WorkStatusEnum
  workerId: number
}

type GetShiftWorkResponse = {
  work: GetShiftWorkResponseWork[]
  unableToAttendWork: GetShiftWorkResponseUnableToAttendWork[]
}

export async function getShiftWork(
  { companyId, shiftId }: GetShiftWorkRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetShiftWorkResponse>(
    `/company/${companyId}/shifts/${shiftId}/work`,
    { signal }
  )
  const { work, unableToAttendWork } = response.data

  return {
    work: work.map(({ lunchLengthOverrideInMinutes, ...workItem }) => ({
      ...workItem,
      lunchLengthOverride: lunchLengthOverrideInMinutes,
    })),
    unableToAttendWork: unableToAttendWork.map(({ workerId, ...workItem }) => ({
      ...workItem,
      worker: { id: workerId },
    })),
  }
}
